import { render, staticRenderFns } from "./examChurchOwn.vue?vue&type=template&id=3eb790bf&scoped=true"
import script from "./examChurchOwn.vue?vue&type=script&lang=js"
export * from "./examChurchOwn.vue?vue&type=script&lang=js"
import style0 from "./examChurchOwn.vue?vue&type=style&index=0&id=3eb790bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb790bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb790bf')) {
      api.createRecord('3eb790bf', component.options)
    } else {
      api.reload('3eb790bf', component.options)
    }
    module.hot.accept("./examChurchOwn.vue?vue&type=template&id=3eb790bf&scoped=true", function () {
      api.rerender('3eb790bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterOwn/examChurchOwn/examChurchOwn.vue"
export default component.exports